import React from "react";
import styled, { css } from "styled-components";
import classNames from "classnames";
import { Row } from "components/bootstrap";
const StyledRow = styled(Row)(
  ({ theme }) => css`
    padding-bottom: 0;

    p {
      margin-top: 15px;
    }

    .actions-lg {
      float: right;
    }

    .actions-sm {
      padding-bottom: 15px;
    }

    .btn-lg {
      font-size: ${theme.fonts.size.large};
    }
  `
);
const ContentHeadRow = ({ children, className = void 0, ...props }) => /* @__PURE__ */ React.createElement(StyledRow, { className: classNames("content-head", className), ...props }, children);
export default ContentHeadRow;
